<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Resumen Campaña</h6>
              <p class="text-sm mb-0 opacity-7" v-if="tipsterLabel">
                Tipster: <b>{{ tipsterLabel }}</b>
              </p>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Campañas</div>
                <div class="v">{{ resumen.campanas_total }}</div>
                <div class="text-xs mt-1">
                  <span class="badge-activas">{{ resumen.campanas_activas ?? 0 }} activa{{ (resumen.campanas_activas ?? 0) !== 1 ? 's' : '' }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Entradas a los canales</div>
                <div class="v">{{ resumen.entradas_total }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Entradas únicas a los canales</div>
                <div class="v">{{ resumen.entradas_unicas_total }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Miembros activos</div>
                <div class="v">{{ resumen.suscritos_actuales_total }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Ventas via campaña</div>
                <div class="v">{{ resumen.compras_total }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Importe</div>
                <div class="v">{{ formatMoney(resumen.importe_total) }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">Páginas de venta</div>
                <div class="v">{{ numPasarelas }}</div>
              </div>
            </div>
            <div v-if="(resumen.importe_pendiente ?? 0) > 0" class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card mini-card--pendiente">
                <div class="k">Por cobrar (trials)</div>
                <div class="v">{{ formatMoney(resumen.importe_pendiente ?? 0) }}</div>
                <div class="text-xs opacity-7">{{ resumen.trials_pendientes ?? 0 }} suscripción{{ (resumen.trials_pendientes ?? 0) !== 1 ? 'es' : '' }}</div>
              </div>
            </div>
          </div>

          <div v-if="!loading && vacio" class="mt-4 alert alert-secondary text-sm">
            No hay datos para mostrar (¿sin campañas?).
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterResumen",
  props: {
    resumen: { type: Object, required: true },
    tipsterLabel: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    vacio: { type: Boolean, default: false },
    numPasarelas: { type: Number, default: 0 },
  },
  methods: {
    formatMoney(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
  },
};
</script>

<style scoped>
.mini-card {
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
  border-radius: 12px;
  padding: 12px 14px;
  height: 100%;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 6px;
}
.mini-card .k {
  font-size: 12px;
  opacity: .7;
  line-height: 1.15;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mini-card .v { font-size: 18px; font-weight: 700; font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
.mini-card--pendiente {
  border-color: rgba(255, 193, 7, 0.4);
  background: rgba(255, 193, 7, 0.07);
}
.mini-card--pendiente .v { color: #ffc107; }
.badge-activas {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(40, 167, 69, 0.15);
  color: #28a745;
  font-weight: 700;
  font-size: 11px;
}
</style>
